import React from "react";


function SignUpInfo({ formData, setFormData }) {
  const handleSelectChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;



  

    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <div className="sign-up-container">
      <div className="col">
        <label htmlFor="interruptorGeneral" className="form-label">
          Interruptor General
        </label>

        <select
          value={formData.interruptorGeneral}
          onChange={handleSelectChange}
          //className="form-select"
          id="interruptorGeneral"
          name="interruptorGeneral"
          required
        >
          <option value={null}>Seleccione</option>
          <option value={6}>6A</option>
          <option value={10}>10A</option>
          <option value={16}>16A</option>
          <option value={20}>20A</option>
          <option value={25}>25A</option>
          <option value={32}>32A</option>
          <option value={40}>40A</option>
        </select>
      </div>
      <div>
        <label htmlFor="nombreInstalador" className="form-label">
          Nombres Instalador
        </label>
        <input
          type="text"
          placeholder="Nombres Instalador"
          value={formData.nombreInstalador}
          onChange={(e) =>
            setFormData({ ...formData, nombreInstalador: e.target.value })
          }
          style={{ textTransform: "capitalize" }}
          required
        />
      </div>

      <div>
        <label htmlFor="apellidoInstalador" className="form-label">
          Apellidos Instalador
        </label>

        <input
          type="text"
          
          placeholder="Apellidos Instalador"
          value={formData.apellidoInstalador}
          onChange={(e) =>
            setFormData({ ...formData, apellidoInstalador: e.target.value })
          }
          style={{ textTransform: "capitalize" }}
          
        />
      </div>

      <div>
        <label htmlFor="folio" className="form-label">
          Folio Instalador
        </label>
        <input
          type="text"
          placeholder="Folio Instalador"
          value={formData.folio}
          onChange={(e) => setFormData({ ...formData, folio: e.target.value })}
          style={{ textTransform: "capitalize" }}
          required
        />
      </div>
      <div>
        <label htmlFor="email" className="form-label">
          Email Instalador
        </label>

        <input
          type="email"
          placeholder="E-mail Instalador"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          style={{ textTransform: "capitalize" }}
          required
        />
      </div>
    </div>
  );
}

export default SignUpInfo;
